"use strict";

exports.__esModule = true;
exports.IconButtonThemes = exports.IconButtonSkins = void 0;
let IconButtonSkins;
exports.IconButtonSkins = IconButtonSkins;
(function (IconButtonSkins) {
  IconButtonSkins["Line"] = "line";
  IconButtonSkins["Full"] = "full";
})(IconButtonSkins || (exports.IconButtonSkins = IconButtonSkins = {}));
let IconButtonThemes;
exports.IconButtonThemes = IconButtonThemes;
(function (IconButtonThemes) {
  IconButtonThemes["None"] = "none";
  IconButtonThemes["Box"] = "box";
})(IconButtonThemes || (exports.IconButtonThemes = IconButtonThemes = {}));
//# sourceMappingURL=types.js.map